export default "__VITE_ASSET__18e45401__"